import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorTypes } from '../enums/errorTypes.enum';
import { ConfigurationService } from '../services/configuration.service';
import { ErrorService } from '../services/error.service';
import { StartupService } from '../services/startup.service';

@Component({
  selector: 'app-load-configuration',
  templateUrl: './load-configuration.component.html',
  styleUrls: ['./load-configuration.component.scss'],
})
export class LoadConfigurationComponent implements OnInit {
  configurationId = '';
  loading = false;
  exists = true;
  invalidGuid = false;

  constructor(
    private startupService: StartupService,
    private configurationService: ConfigurationService,
    private router: Router,
    private errorService: ErrorService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (!this.activatedRoute.snapshot.queryParamMap.has('token')) {
      this.router.navigate(['/']);
    }
  }

  updateConfiguration(configurationId: string) {
    this.configurationId = configurationId;
  }

  load() {
    if (this.configurationId) {
      this.loading = true;
      this.exists = true;
      this.invalidGuid = false;
      this.configurationService.doesConfigurationExist(this.configurationId).subscribe(
        result => {
          this.loading = false;
          if (result === null) {
            this.invalidGuid = true;
          } else if (result) {
            this.startupService.loadConfiguration(this.configurationId);
            this.router.navigate(['/'], { queryParamsHandling: 'merge' });
          } else {
            this.exists = false;
          }
        },
        err => this.errorService.throwError(ErrorTypes.BackendNotFound, 'ConfigurationExists' + err.status)
      );
    }
  }
}
